import { useLocation } from '@reach/router';
import { AxiosError } from 'axios';
import { navigate } from 'gatsby';
import React from 'react';
import { Container, Row } from 'react-bootstrap';
import SearchListing from '../../components/search_listing/SearchListing';
import { handleFacetChange } from '../../utils/helpers';

interface Base {
  error: unknown;
  isFetching: boolean;
  contextualFilters?: SearchParams;
  defaultLoadedState?: boolean;
}

interface Api extends Base {
  data: DrupalSearch | undefined;
  serverData?: DrupalSearch;
}

interface Server extends Base {
  data: DrupalSearch | undefined;
  serverData: DrupalSearch;
}

const ArticleListingBody: React.FC<Server | Api> = ({
  data,
  serverData,
  error,
  isFetching,
  contextualFilters,
  defaultLoadedState,
}) => {
  const location = useLocation();
  return (
    <Container className="my-5">
      <SearchListing
        data={data}
        error={(error as AxiosError) || new Error('Sorry, there was an error')}
        loaded={!isFetching}
        defaultLoadedState={defaultLoadedState}
        brazeCardPayloads={[]}
      >
        <>
          <Row className="align-items-center py-3">
            <SearchListing.SearchHeader
              title=""
              typeOfResult="articles"
              hideFilters
              onFacetRemove={e => handleFacetChange(e, location, navigate, contextualFilters)}
            />
          </Row>
          <SearchListing.ArticleSearchResults serverData={serverData} />
          <div className="pds-flex pds-justify-center md:pds-justify-end">
            <SearchListing.Pagination serverData={serverData} />
          </div>
        </>
      </SearchListing>
    </Container>
  );
};
export default ArticleListingBody;
